// ================================================================
// scenarioStore — سناریوی شرکتِ فعال را روی canvas نگه می‌دارد و
// تغییرات را (debounced) در همان سناریوی شرکت ذخیره می‌کند.
// ================================================================
import { state } from './state.js';
import { events, EVENTS } from './events.js';
import { getCompanyScenario, saveScenario } from './scenarios.js';

let current = null; // { id, organizationId, name }
let saveTimer = null;

export function getCurrentScenario() {
  return current;
}

// سناریوی یک شرکت را باز کن و روی canvas بنشان
export async function openCompanyScenario(organizationId) {
  const { scenario } = await getCompanyScenario(organizationId);
  current = {
    id: scenario.id,
    organizationId: scenario.organizationId,
    name: scenario.name,
  };
  state.loadSnapshot(scenario.data || {});
  return current;
}

function scheduleSave() {
  if (!current) return;
  clearTimeout(saveTimer);
  saveTimer = setTimeout(flush, 600);
}

async function flush() {
  if (!current) return;
  const snapshot = {
    nodes: state.nodes,
    connections: state.connections,
    nextId: state.nextId,
  };
  try {
    await saveScenario(current.id, current.organizationId, { data: snapshot });
  } catch (err) {
    console.warn('Could not save scenario:', err);
  }
}

// هر تغییری روی state → ذخیره در سناریوی شرکتِ فعال (اگر شرکتی باز است)
export function initScenarioStore() {
  events.on(EVENTS.STATE_CHANGED, scheduleSave);
}
